import { render, staticRenderFns } from "./PCBs.vue?vue&type=template&id=34fb0355&"
import script from "./PCBs.vue?vue&type=script&lang=js&"
export * from "./PCBs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports